/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedProjectsRouteImport } from './routes/_authenticated/projects'
import { Route as AuthenticatedEmailRouteImport } from './routes/_authenticated/email'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsRoute = AuthenticatedProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmailRoute = AuthenticatedEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/email': typeof AuthenticatedEmailRoute
  '/projects': typeof AuthenticatedProjectsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/email': typeof AuthenticatedEmailRoute
  '/projects': typeof AuthenticatedProjectsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/activity': typeof AuthenticatedActivityRoute
  '/_authenticated/billing': typeof AuthenticatedBillingRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/email': typeof AuthenticatedEmailRoute
  '/_authenticated/projects': typeof AuthenticatedProjectsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/activity'
    | '/billing'
    | '/calendar'
    | '/email'
    | '/projects'
    | '/settings'
    | '/auth/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/activity'
    | '/billing'
    | '/calendar'
    | '/email'
    | '/projects'
    | '/settings'
    | '/auth/callback'
    | '/'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/activity'
    | '/_authenticated/billing'
    | '/_authenticated/calendar'
    | '/_authenticated/email'
    | '/_authenticated/projects'
    | '/_authenticated/settings'
    | '/auth/callback'
    | '/_authenticated/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects': {
      id: '/_authenticated/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedProjectsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email': {
      id: '/_authenticated/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof AuthenticatedEmailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing': {
      id: '/_authenticated/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedActivityRoute: typeof AuthenticatedActivityRoute
  AuthenticatedBillingRoute: typeof AuthenticatedBillingRoute
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedEmailRoute: typeof AuthenticatedEmailRoute
  AuthenticatedProjectsRoute: typeof AuthenticatedProjectsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,
  AuthenticatedBillingRoute: AuthenticatedBillingRoute,
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedEmailRoute: AuthenticatedEmailRoute,
  AuthenticatedProjectsRoute: AuthenticatedProjectsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
